
define('text!presentation/inbox/views/inbox.html',[],function () { return '<div class="inbox">\n\n</div>';});

